export default __webpack_public_path__ + "static/media/job_offer3_l.84df5a7d.jpg";